// extracted by mini-css-extract-plugin
module.exports = {"form":"input-module--form--23rDP","formGroup":"input-module--formGroup--mPws7","formControl":"input-module--formControl--2yCK-","type":"input-module--type--_QSJ9"};